// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DocumentMetaIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "aria-hidden": "true",
  "data-icon": "DocumentMeta/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 14.665h4c3.334 0 4.667-1.333 4.667-4.666v-4c0-3.334-1.333-4.667-4.667-4.667H6c-3.333 0-4.667 1.333-4.667 4.667v4c0 3.333 1.334 4.666 4.667 4.666ZM10.5 6h-5M10.5 10h-5"
}));
export default DocumentMetaIcon;